import TakeOutAdvanceRouter from 'features/advance/screens/registration/TakeOutAdvance/TakeOutAdvanceRouter';
import React from 'react';

const New = () => {
  return <TakeOutAdvanceRouter />;
};

export default New;
